import styled from 'styled-components';

export const Tabs = styled.div`
  display: flex;
`;
